import { render, staticRenderFns } from "./Stencil.vue?vue&type=template&id=3912da98&"
import script from "./Stencil.vue?vue&type=script&lang=js&"
export * from "./Stencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports